module.exports = __webpack_public_path__ + "static/media/logo-digix-ciano.fc9baeb8.svg";